import { render, staticRenderFns } from "./SimulationView.vue?vue&type=template&id=dd87e636&"
import script from "./SimulationView.vue?vue&type=script&lang=js&"
export * from "./SimulationView.vue?vue&type=script&lang=js&"
import style0 from "./SimulationView.vue?vue&type=style&index=0&id=dd87e636&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports